import { Injectable, inject } from '@angular/core';
import { DeviceState } from '@era/locations-sdk';
import { DeviceStoreActions } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UnassignedDevicesResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    this.store.dispatch(
      DeviceStoreActions.DeviceResolverActions.devicesForStateRequested({
        state: DeviceState.Unassigned,
      })
    );
    return of(true);
  }
}
